<script>
  import { createEventDispatcher } from 'svelte';

  import { chainExplorer } from '../stores.js';

  import { compressString, copyTextToClipboard } from '../utils.js'

  import Connect from './connect.svelte';

  export let address;
  export let compact = undefined;
  export let type = 'address';
  export let copiable = true;

  $: compacted = compressString(address, compact);
  $: mobile = compressString(address, 4);
  $: url = $chainExplorer ? `${ $chainExplorer.url }/${ type }/${ address }` : undefined;

  const copy = () => {
    copyTextToClipboard(address);
    dispatch('copied');
    new CustomEvent('copied');
  }

  const dispatch = createEventDispatcher();
</script>

{#if $chainExplorer}
  <div class={ $$props.class } class:lt-explorer={ true }>
    {#if compact === 'auto'}
      <a href={ url } target="_blank" class="mobile" rel="noopener noreferrer">{ address }</a>
      <a href={ url } target="_blank" class="desktop" rel="noopener noreferrer">{ mobile }</a>
    {:else if compact}
      <a href={ url } target="_blank" class="desktop" rel="noopener noreferrer">{ compacted }</a>
    {:else}
      <a href={ url } target="_blank" rel="noopener noreferrer">{ address }</a>
    {/if}
    {#if copiable}
      <!-- svelte-ignore a11y-no-static-element-interactions -->
      <!-- svelte-ignore a11y-click-events-have-key-events -->
      <span class="copy" on:click={ copy }><slot name="copiable">&#128203;</slot></span>
    {/if}
  </div>
{:else}
  <Connect />
{/if}